import { InfoOutlined } from '@mui/icons-material'
import React from 'react'
import { Card, Col, Row } from 'reactstrap'
import { KYC_NOTE_EDIT_1, KYC_NOTE_EDIT_2, KYC_NOTE_EDIT_3 } from '../../../../constant'

const KycEditNote = (props) => {
  const { tan_number } = props;
  return (
    <>
      {/* <Row style={{ marginTop: "30px" }}> */}
      {/* <Col xl="12" md="12"> */}
      <Card style={{ backgroundColor: "#E7E4FF", marginBottom: '0px' }}>
        <h6 style={{ color: '#7366FF', fontSize: '1rem', margin: '10px' }}><InfoOutlined style={{ fontSize: '1rem', marginBottom: '-3px' }} /> Note</h6>
        {tan_number && (
          <p style={{ fontSize: '0.8rem', lineHeight: '1.4', paddingLeft: '15px', marginBottom: '10px' }}>
            {KYC_NOTE_EDIT_3}
          </p>
        )}
        <p style={{ fontSize: '0.8rem', lineHeight: '1.4', paddingLeft: '15px' }}>
          {KYC_NOTE_EDIT_1}
        </p>
        <p style={{ fontSize: '0.8rem', lineHeight: '1.4', paddingLeft: '15px', marginBottom: '10px' }}>
          {KYC_NOTE_EDIT_2}
        </p>
      </Card>
      {/* </Col> */}
      {/* </Row> */}
    </>
  )
}

export default KycEditNote
